import { Observable } from 'rxjs';

import { UseCase } from '../base/use-case';
import { RecommendationModel } from '../domain/recommendation.model';
import { RecommendationsRepository } from '../repositories/recommendations.repository';

export class GetRecommendationsUseCase implements UseCase<void, RecommendationModel[]> {
  constructor(private recommendationsRepository: RecommendationsRepository) {}

  execute(): Observable<RecommendationModel[]> {
    return this.recommendationsRepository.getRecommendations();
  }
}
